import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";

import { InputText } from "primereact/inputtext";
import {
  ComplaintInfosDTO,
  DropDownList,
  relationShip,
  StepCallBack,
} from "@modules/plaintes/plaintes.model.ts";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { useAppDispatch, useAppSelector } from "@core/store/hook.ts";
import {
  guichetUnique,
  loadingMembersGuichetUnique,
  membersGuichetUnique,
  setStepReasonValue,
  stepReasonValue,
} from "@core/slice/ComplaintSlice.ts";
import { formatFullName } from "@utils/appUtils.ts";
import { getPhoneMaxLength } from "@modules/setting/userManagement/user.model.ts";
import { getGuichetUnique, getMembersByHouseholdId } from "@core/actions/complaintAction.ts";
import { Dialog } from "primereact/dialog";
import { FetchStatusType } from "@core/modeles/model.ts";
import Message from "@shared/message/Message.tsx";

const ComplainantInfos: React.FC<StepCallBack> = ({
  isResolvedComplaint,
  onNext,
  onPrevious,
}) => {
  // Button radio
  const dispatch = useAppDispatch();
  const stepReason = useAppSelector(stepReasonValue);
  const guichetUniqueData = useAppSelector(guichetUnique);
  const membersGU = useAppSelector(membersGuichetUnique);
  const loadingMembers = useAppSelector(loadingMembersGuichetUnique);
  const [householdId, setHouseholdId] = useState<string>("");
  const [individualId, setIndividualId] = useState<string>("");
  const [complainantInfos, setComplainantInfos] = useState<ComplaintInfosDTO>({
    fullName: "",
    cinNumber: "",
    phoneNumber: "",
    householdId: "",
    individualId: "",
    address: "",
    relationshipWithVictim: "",
    disabled: false,
    anonym: false,
    isVictim: false,
  });

  const [cin, setCin] = useState(Array(12).fill("")); // 12 cases pour le CIN

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isMembers, setIsMembers] = useState<boolean>(false);
  const [dialogMessage, setDialogMessage] = useState<any>();
  const [open, setOpen] = useState(false);
   const [visibleConfirmDialog, setVisibleConfirmDialog] =
      React.useState<boolean>(false);

  const [errors, setErrors] = useState({
    name: "",
    address: "",
    phoneNumber: "",
  });

    const [messageInfo, setMessageInfo] = useState<{
      severity: "success" | "info" | "warn" | "error";
      summary: string;
      detail: string;
    }>({ severity: "success", summary: "", detail: "" });

  const [selectedRelationShip, setSelectedRelationShip] =
    useState<DropDownList>();

   const showMessage = (
    severity: "success" | "info" | "warn" | "error",
    summary: string,
    detail: string
  ) => {
    setMessageInfo({ severity, summary, detail });
    setOpen(true);
  };

  useEffect(() => {
    if (stepReason && stepReason.stepTwo) {
      if (validatePhoneNumber(stepReason.stepTwo.phoneNumber)) {
        setErrors({
          ...errors,
          phoneNumber: validatePhoneNumber(stepReason.stepTwo.phoneNumber),
        });
      }
      const findRelation = relationShip.find(
        (e) => e.code === stepReason.stepTwo?.relationshipWithVictim
      );
      if (findRelation) {
        setSelectedRelationShip(findRelation);
      }
      setComplainantInfos(stepReason.stepTwo);
      setCin(stepReason.stepTwo.cinNumber.split(""));
      setFirstName(stepReason.stepTwo.fullName ?? "");
      setLastName(stepReason.stepTwo.lastName ?? "");
      if (stepReason.stepTwo.cinNumber.length === 0) {
        setCin(Array(12).fill(""));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepReason]);

  useEffect(() => {
    if (!householdId && !individualId) return;
    const timeoutId = setTimeout(() => {
      dispatch(
        getGuichetUnique({
          filter: { householdId, individualId },
          onSuccess: (response) => {
            
          },
          onError: () => {
            setDialogMessage(
                "Plaignant introuvable. Veuillez vérifier les identifiants fournis."
              );
            setVisibleConfirmDialog(true);
            setHouseholdId("");
          }
        })
      );
    }, 200);
    return () => clearTimeout(timeoutId);
  }, [householdId, individualId, dispatch]);

  useEffect(() => {
    const householdId = complainantInfos.householdId?.trim();
    if(!householdId) return;
    const timeoutId = setTimeout(() => {
      dispatch(
        getMembersByHouseholdId({ 
          householdId,
          onSuccess: (response) => {
            if (response.length === 0) {
              setIsMembers(false);
              setDialogMessage(
                    "Membres du ménage introuvables. Veuillez vérifier l'identifiant du ménage fourni."
                  );
                setVisibleConfirmDialog(true);
            } else {
              setIsMembers(true);
            }
          },
          onError: () => {
            showMessage(
              "error",
              "Erreur",
              "Une erreur s'est produite "
            );
            // setVisibleConfirmDialog(true);
            }
          })
      );
    }, 200);
    return () => clearTimeout(timeoutId);
  }, [complainantInfos.householdId, dispatch]);

  useEffect(() => {
    if (!guichetUniqueData?.complainant) return;
    const { householdId, individualId, fullName, disabled, phoneNumber, cinNumber, address } =
      guichetUniqueData.complainant;
    setComplainantInfos((prev) => ({
      ...prev,
      householdId: householdId ?? prev.householdId,
      individualId: individualId ?? prev.individualId,
      fullName: fullName ?? prev.fullName,
      disabled: disabled ?? prev.disabled,
      phoneNumber: phoneNumber ?? prev.phoneNumber,
      cinNumber: cinNumber ?? prev.cinNumber,
      address: address ?? prev.address,
    }));
    setCin(cinNumber ? cinNumber.split("") : Array(12).fill(""));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guichetUniqueData]);

  // useEffect(() => {
  //   if( !membersGU || membersGU.length === 0) return;
  //   setComplainantInfos((prev) => ({
  //     ...prev,
  //     individualId: membersGU[0].individualId ?? prev.individualId,
  //   }));

  // }, [membersGU]);


  function handleCINChange(e: React.ChangeEvent<HTMLInputElement>, index: any) {
    const value = e.target.value;

    if (!/^\d?$/.test(value)) return;

    const newCin = [...cin];
    newCin[index] = value.slice(0, 1);
    setCin(newCin);

    const allFilled = newCin.every((char) => char.length === 1);
    if (allFilled) {
      const completeCIN = newCin.join("");
      setComplainantInfos((prev) => ({
        ...prev,
        cinNumber: completeCIN,
      }));
      if (stepReason) {
        dispatch(
          setStepReasonValue({
            ...stepReason,
            stepTwo: {
              ...complainantInfos,
              cinNumber: completeCIN,
            },
          })
        );
      }
    }

    // Passage automatique au champ suivant si un chiffre est saisi
    if (value && index < cin.length - 1) {
      document.getElementById(`cin-input-${index + 1}`)?.focus();
    }
  }

  const validatePhoneNumber = (params: string) => {
    let updatedErrors = { ...errors };
    const value = params.replace(/\s/g, ""); // Retirer les espaces

    const localPhoneRegex = /^(032|033|034|038|037|020)\d{7}$/;
    const internationalPhoneRegex = /^\+261(32|33|34|38|37|20)\d{7}$/;

    if (
      !localPhoneRegex.test(value) &&
      !internationalPhoneRegex.test(value) &&
      value !== ""
    ) {
      updatedErrors.phoneNumber =
        "Numéro valide: 032|033|034|038|037|020xxxxxxx  +261xxxxxxxxx (ex: 032xxxxxxx ou +26132xxxxxxx)";
    } else {
      updatedErrors.phoneNumber = "";
    }

    return updatedErrors.phoneNumber;
  };

  const capitalizeFirstLetter = (value: string) =>
    value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    let updatedErrors = { ...errors };
    setComplainantInfos((prevInfos) => ({
      ...prevInfos,
      [name]: value,
    }));

    if (name === "fullName") {
      const formattedValue = formatFullName(value);
      setComplainantInfos((prev) => ({ ...prev, fullName: formattedValue }));
      updatedErrors.name = "";
    }
    if(name === "householdId") {
      if(value === "") {
        setIsMembers(false);
        setComplainantInfos((prev) => ({ 
          ...prev, 
          individualId: "",
          fullName: "",
          householdId: "",
          phoneNumber: "",
          cinNumber: "",
          address: "",
          isVictim: false,
        }));
      }
    }
    if (name === "address") {
      updatedErrors.address = "";
    }
    if (!isResolvedComplaint) {
      if (name === "firstName") {
        const formattedValue = capitalizeFirstLetter(value);
        setFirstName(formattedValue);
        setComplainantInfos((prevInfos) => ({
          ...prevInfos,
          fullName: `${formattedValue} ${lastName}`.trim(),
        }));
      } else if (name === "lastName") {
        const formattedValue = formatFullName(value);
        setLastName(formattedValue);
        setComplainantInfos((prevInfos) => ({
          ...prevInfos,
          fullName: `${firstName} ${formattedValue}`.trim(),
        }));
        updatedErrors.name = "";
      }
    }
    if (name === "phoneNumber") {
      updatedErrors.phoneNumber = validatePhoneNumber(value);
    }

    setErrors(updatedErrors);
  };

  const handleNextStep = () => {
    if (!complainantInfos.anonym) {
      let formErrors = { ...errors };
      if (complainantInfos.fullName?.trim() === "") {
        formErrors.name = "Veuillez remplir le champ Nom";
      } else {
        formErrors.name = "";
      }
      if (complainantInfos.address.trim() === "") {
        formErrors.address = "Veuillez remplir le champ adresse";
      } else {
        formErrors.address = "";
      }
      setErrors(formErrors);
      if (!formErrors.name && !formErrors.address && !errors.phoneNumber) {
        if (stepReason) {
          dispatch(
            setStepReasonValue({ ...stepReason, stepTwo: complainantInfos, victimStep: guichetUniqueData?.victim ?? null })
          );
        }
        onNext();
      }
    } else {
      if (stepReason) {
        dispatch(
          setStepReasonValue({ ...stepReason, stepTwo: complainantInfos })
        );
      }
      onNext();
    }
  };

  function handlePreviousStep() {
    if (onPrevious) {
      if (stepReason) {
        dispatch(
          setStepReasonValue({ ...stepReason, stepTwo: complainantInfos })
        );
        onPrevious();
      }
    }
  }
  return (
    <div className="column gap-5 h-12rem card-stepper">
      <Message
        open={open}
        severity={messageInfo.severity}
        summary={messageInfo.summary}
        detail={messageInfo.detail}
      />
      <div className="stitle">Informations sur le plaignant</div>
      {/* Dialog */}
      <Dialog
        header={
          <div
            style={{ display: "flex", alignItems: "baseline", gap: "0.5rem", color: "#ed1327", padding: "0.5rem" }}
          >
            
            <span>Plaignant introuvable</span>
          </div>
        }
        visible={visibleConfirmDialog}
        style={{ width: "30vw" }}
        onHide={() => {
          setVisibleConfirmDialog(false);
        }}
      >
        <p className="m-0">{dialogMessage}</p>
      </Dialog>
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="column gap-1">
          Voulez-vous rester anonyme ?
          <div className="flex flex-wrap gap-3">
            <div className="flex align-items-center radio">
              <RadioButton
                inputId="anonyme"
                name="anonyme"
                value={complainantInfos.anonym}
                onChange={(e: RadioButtonChangeEvent) =>
                  setComplainantInfos((prevInfos) => ({
                    ...prevInfos,
                    anonym: true,
                  }))
                }
                checked={complainantInfos.anonym === true}
              />
              <label htmlFor="anonyme" className="ml-2">
                Oui
              </label>
            </div>
            <div className="flex align-items-center radio">
              <RadioButton
                inputId="noanonyme"
                name="anonyme"
                value={complainantInfos.anonym}
                onChange={(e: RadioButtonChangeEvent) =>
                  setComplainantInfos((prevInfos) => ({
                    ...prevInfos,
                    anonym: false,
                  }))
                }
                checked={complainantInfos.anonym === false}
              />
              <label htmlFor="noanonyme" className="ml-2">
                Non
              </label>
            </div>
          </div>
        </div>

        <div className="column gap-1">
          Cette plainte concerne-t-elle vous-même ou une autre personne ?
          <div className="flex flex-wrap gap-3">
            <div className="flex align-items-center radio">
              <RadioButton
                inputId="victim"
                name="victim"
                value={complainantInfos.isVictim}
                onChange={(e: RadioButtonChangeEvent) =>
                  setComplainantInfos((prevInfos) => ({
                    ...prevInfos,
                    isVictim: true,
                  }))
                }
                checked={complainantInfos.isVictim === true}
              />
              <label htmlFor="victim" className="ml-2">
                Moi-même - Je suis la victime directe
              </label>
            </div>
            <div className="flex align-items-center radio">
              <RadioButton
                inputId="noVictim"
                name="noVictim"
                value={complainantInfos.isVictim}
                onChange={(e: RadioButtonChangeEvent) =>
                  setComplainantInfos((prevInfos) => ({
                    ...prevInfos,
                    isVictim: false,
                  }))
                }
                checked={complainantInfos.isVictim === false}
              />
              <label htmlFor="noVictim" className="ml-2">
                Une autre personne - Je déclare pour le compte d'un tiers
              </label>
            </div>
          </div>
        </div>
      </div>

      {!complainantInfos.anonym && (
        <>
          <div>
            {isResolvedComplaint && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex flex-col gap-2">
                  <label htmlFor="householdId">ID ménage</label>
                  <InputText
                    id="householdId"
                    name="householdId"
                    value={complainantInfos.householdId}
                    placeholder="ID ménage"
                    aria-describedby="username-help"
                    onChange={handleInputChange}
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label htmlFor="individualId">ID individu </label>
                  <InputText
                    id="individualId"
                    name="individualId"
                    value={complainantInfos.individualId}
                    placeholder="ID individu"
                    aria-describedby="username-help"
                    onChange={handleInputChange}
                    disabled
                  />
                </div>

                <div className="flex flex-col gap-2">
                  <label htmlFor="username">
                    Nom du plaignant (Obligatoire)
                  </label>
                  {
                    !isMembers ? (
                      <InputText
                        id="name"
                        name="fullName"
                        value={formatFullName(complainantInfos.fullName)}
                        placeholder="Nom du plaignant"
                        aria-describedby="username-help"
                        onChange={handleInputChange}
                        maxLength={255}
                      />
                    ) : (
                      <Dropdown 
                        value={complainantInfos.fullName} 
                        onChange={(e) => {
                          setComplainantInfos((prev) => ({
                            ...prev,
                            individualId: e.value.individualId,
                            fullName: e.value.fullName,
                          }));
                          setIndividualId(e.value.individualId);
                          setHouseholdId(complainantInfos.householdId);
                        }} 
                        options={membersGU ?? []} 
                        optionLabel="fullName" 
                        editable 
                        placeholder="Selectionner un membre du ménage" 
                        className="w-full md:w-14rem"
                        disabled={loadingMembers === FetchStatusType.LOADING}
                        dropdownIcon={
                          loadingMembers === FetchStatusType.LOADING ? (
                            <i className="pi pi-spinner pi-spin" />
                          ) : undefined
                        }
                      />
                  )}
                  
                  {/* */}
                  {errors.name && (
                    <small className="text-red-600">{errors.name}</small>
                  )}
                </div>
                <div className="flex flex-col gap-2">
                  Êtes-vous une personne handicapée
                  <div className="flex flex-wrap gap-3">
                    <div className="flex align-items-center radio">
                      <RadioButton
                        inputId="handicap"
                        name="disabled"
                        value={complainantInfos.disabled}
                        onChange={(e: RadioButtonChangeEvent) =>
                          setComplainantInfos((prevInfos) => ({
                            ...prevInfos,
                            disabled: true,
                          }))
                        }
                        checked={complainantInfos.disabled === true}
                      />
                      <label htmlFor="handicap" className="ml-2">
                        Oui
                      </label>
                    </div>
                    <div className="flex align-items-center radio">
                      <RadioButton
                        inputId="nohandicap"
                        name="disabled"
                        value={complainantInfos.disabled}
                        onChange={(e: RadioButtonChangeEvent) =>
                          setComplainantInfos((prevInfos) => ({
                            ...prevInfos,
                            disabled: false,
                          }))
                        }
                        checked={complainantInfos.disabled === false}
                      />
                      <label htmlFor="nohandicap" className="ml-2">
                        Non
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <label htmlFor="phoneNumber">Numéro téléphone </label>
                  <InputText
                    id="phoneNumber"
                    name="phoneNumber"
                    value={complainantInfos.phoneNumber}
                    placeholder="Numéro téléphone"
                    aria-describedby="phoneNumber-help"
                    onChange={handleInputChange}
                    maxLength={getPhoneMaxLength(complainantInfos.phoneNumber)}
                  />
                  {errors.phoneNumber && (
                    <small className="text-red-600">{errors.phoneNumber}</small>
                  )}
                </div>
                <div className="flex flex-col gap-2">
                  <label htmlFor="username">Numéro CNI</label>
                  <div className="w-full flex justify-content-center gap-3 flex-wrap">
                    {cin.map((value, index) => (
                      <InputText
                        key={`${index}`}
                        id={`cin-input-${index}`}
                        value={value}
                        onChange={(e) => handleCINChange(e, index)}
                        maxLength={1} // Limite la saisie à un seul caractère
                        style={{
                          width: "calc(100% /12)",
                          height: "38px",
                          textAlign: "center",
                          fontSize: "12px",
                          borderRadius: "4px",
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>
            )}

            {!isResolvedComplaint && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex flex-col gap-2">
                  <div className="column gap-2 w-full">
                    <label htmlFor="firstName">
                      Nom du plaignant (Obligatoire)
                    </label>
                    <InputText
                      id="firstName"
                      name="firstName"
                      placeholder=""
                      value={formatFullName(firstName)}
                      aria-describedby="username-help"
                      onChange={handleInputChange}
                      maxLength={255}
                    />
                    {errors.name && (
                      <small className="text-red-600">{errors.name}</small>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <div className="column gap-2 w-full">
                    <label htmlFor="phoneNumber">Numéro téléphone </label>
                    <InputText
                      id="phoneNumber"
                      name="phoneNumber"
                      value={complainantInfos.phoneNumber}
                      placeholder="Numéro téléphone"
                      aria-describedby="phoneNumber-help"
                      onChange={handleInputChange}
                      maxLength={10}
                    />
                    {errors.phoneNumber && (
                      <small className="text-red-600">
                        {errors.phoneNumber}
                      </small>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <div className="column gap-2 w-full">
                    <label htmlFor="relationshipWithVictim">
                      Relation avec la victime
                    </label>
                    <Dropdown
                      id="situation"
                      value={selectedRelationShip}
                      onChange={(e: DropdownChangeEvent) => {
                        setSelectedRelationShip(e.value);
                        setComplainantInfos((prev) => ({
                          ...prev,
                          relationshipWithVictim: e.value.code,
                        }));
                      }}
                      options={relationShip}
                      optionLabel="name"
                      placeholder="--- Relation avec la victime ---"
                      className="w-full md:w-14rem"
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <div className="column gap-2 w-full">
                    <label htmlFor="address">Adresse (obligatoire)</label>
                    <InputText
                      id="address"
                      name="address"
                      value={complainantInfos.address}
                      placeholder=""
                      aria-describedby="username-help"
                      onChange={handleInputChange}
                      maxLength={255}
                    />

                    {errors.address && (
                      <small className="text-red-600">{errors.address}</small>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          {isResolvedComplaint && (
            <div className="flex flex-wrap gap-3 w-full">
              <div className="column gap-2 w-full">
                <label htmlFor="address">Adresse (Obligatoire)</label>
                <InputText
                  id="address"
                  name="address"
                  value={complainantInfos.address}
                  placeholder="Adresse"
                  aria-describedby="username-help"
                  onChange={handleInputChange}
                  maxLength={255}
                />

                {errors.address && (
                  <small className="text-red-600">{errors.address}</small>
                )}
              </div>
            </div>
          )}
        </>
      )}
      <div className="flex pt-4 gap-3 justify-content-end">
        <div className="flex pt-4 justify-content-end">
          <Button
            label="Précédent"
            className="btn btn-secondary w-[120px]"
            onClick={handlePreviousStep}
          />
        </div>
        <div className="flex pt-4 justify-content-end">
          <Button
            label="Suivant"
            className="btn btn-primary w-[120px]"
            onClick={handleNextStep}
          />
        </div>
      </div>
    </div>
  );
};

export default ComplainantInfos;
